// login flow
export const LOGIN_PATH = '/auth/login';
export const PASSWORD_PATH = '/auth/login/password';
export const VERIFY_WITH_AUTHENTICATOR_PATH = '/auth/login/verify-authenticator';
export const TRUSTED_DEVICE_PATH = '/auth/login/trusted-device';

// sign out page
export const SIGN_OUT_PATH = '/signed-out';

// invitation flow
export const CREATE_ACCOUNT_PATH = '/auth/create-account';
export const INVITATION_PATH = '/auth/invitation';

// reset password
export const RESET_PASSWORD_PATH = '/auth/reset-password';
// rotate password
export const ROTATE_CRED_PATH = '/auth/reset-password/rotate-cred';
export const RESET_PASSWORD_VERIFY_AUTHENTICATOR_PATH = '/auth/reset-password/verify-authenticator';
export const RESET_PASSWORD_VERIFY_EMAIL_PATH = '/auth/reset-password/verify-email';
export const RESET_PASSWORD_VERIFY_PHONE_PATH = '/auth/reset-password/verify-phone';
export const RESET_PASSWORD_CHANGE_PASSWORD_PATH = '/auth/reset-password/password';

// reset authenticator flow
export const RESET_AUTHENTICATOR_PATH = '/auth/reset-authenticator';

// recover account
export const RECOVER_ACCOUNT_PATH = '/auth/recover-account';

// account routes
export const HOME_PATH = '/account';
export const SETTINGS_PATH = '/account/settings';
export const EMAIL_PREFERENCES_PATH = '/account/settings/email-preferences';

// support links
export const FAQ_PATH = '/faq';
export const WAYTO_FAQ_PATH = '/wayto/faq';

// error page
export const ERROR_PATH = '/error';
